<template>
	<div class="l-body">
	<Top/>
	<div class="wrap zhuizong">
	<div class="l-wrap zheng" style="margin-top:300px">
	<div class="help-menu-box">
	<h1>游戏产品列表</h1>
	<div class="st_tree">
	<ul>
	<li @click="an(1)"><a>客户端游戏</a></li>
	<ul class="tree_n" v-show="s1">
	<li v-for="data in objData" v-if="data.type==1"><a target="_blank" @click='$router.push({path:"/tracklist", query:{gid:data.id}})'>{{data.game}}</a></li>
	</ul>
	<!-- <li @click="an(2)"><a>网页游戏</a></li>
	<ul class="tree_n" v-show="s2">
	<li v-for="data in objData" v-if="data.type==2"><a target="_blank" @click='$router.push({path:"/tracklist", query:{gid:data.id}})'>{{data.game}}</a></li>
	</ul>
	<li  @click="an(3)"><a>手机游戏</a></li>
	<ul class="tree_n" v-show="s3">
	<li v-for="data in objData" v-if="data.type==3"><a target="_blank" @click='$router.push({path:"/tracklist", query:{gid:data.id}})'>{{data.game}}</a></li>
	</ul> -->
	</ul>
	</div>
	</div>
	<div class="help-jl-box">
	<h1>服务记录追踪</h1>
	<div class="xiangxi">
	<table class="biaoge">
	<tr>
	<th colspan="2"><p class="youp"><span id="">{{time}}</span><span id="liushui">流水号：{{liushui}}</span></p><p class="zuop"><span id="level">{{vip}}</span></p></th>
	</tr>
	<tr>
	<td width="70%">
	<p class="gamename">游戏名称：{{game}}</p>
	<p class="ywutype">业务类型：{{tname}}</p>
	</td>
	<td>
	<p class="jindu">处理进度</p>
	<p class="jindu2">{{thejd}}</p>
	</td>
	</tr>
	</table>
	<table class="biaoge">
	<tr>
	<th><p class="youp">客服反馈信息</p></th>
	</tr>
	<tr>
	<td width="100%">
	<div class="fkui" v-for="data in qData">
	<div>客服回复时间：{{data.create_time}}</div>
	<div v-html="data.data"/>
	</div>
	</td>
	</tr>
	</table>
	<div class="newstab">
	<el-pagination
	  @current-change="handleCurrentChange"
	  :page-size="4"
	  layout="prev, pager, next"
	  :total="total">
	</el-pagination>
	</div>
	<table class="biaoges">
	<tr>
	<th><p class="youp">请提交您的信息</p></th>
	</tr>
	<tr>
	<td width="100%"><textarea name="reworkmes" cols="58" rows="5" v-model="word">请输入.....</textarea></td>
	</tr>
	<tr>
	<FontOnlyUpload v-model="imgList" @input="" class="width"></FontOnlyUpload>
	</tr>
	<tr>
	<td width="100%" class="anniu"><a @click="sub">发送消息</a></td>
	</tr>
	</table>
	<br>
	<table class="biaoges" v-show="show">
	<tr>
	<th>
	<p class="youp">请您对本次服务进行评分：</p>
	<p>
	<fieldset class="starability-basic">
	<input type="radio" id="rate5-1" name="rating" value="5" v-model="num"/>
	<label for="rate5-1">5stars</label>
	<input type="radio" id="rate4-1" name="rating" value="4" v-model="num"/>
	<label for="rate4-1">4stars</label>
	<input type="radio" id="rate3-1" name="rating" value="3" v-model="num"/>
	<label for="rate3-1">3stars</label>
	<input type="radio" id="rate2-1" name="rating" value="2" v-model="num"/>
	<label for="rate2-1">2stars</label>
	<input type="radio" id="rate1-1" name="rating" value="1" v-model="num"/>
	<label for="rate1-1">1star</label>
	</fieldset>
	</p>
	</th>
	</tr>
	<tr>
	<td width="100%"><textarea name="reworkmes" cols="58" rows="5" v-model="word1">请您对本次服务做出评价，欢迎您的宝贵意见。</textarea></td>
	</tr>
	<tr>
	<td width="100%" class="annius"><a @click="sub1">发送评分</a></td>
	</tr>
	</table>
	</div>
	<div class="hujiao">
	<p>您的问题是否得到了解决？如果没有，您可以尝试：</p>
	<p>呼叫在线客服：<a href='http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDEwMzM3N180NTIzMjdfODAwMTAzMzc3XzJf'>在线客服</a></p>
	</div>
	</div>
	</div>
	</div>
	</div>
</template>

<script>
	import Top from '@/components/top.vue'
	import FontOnlyUpload from "@/components/Font-onlyuoload.vue";
	export default {
	  name: "tracking",
	  components: {
	    Top,
		FontOnlyUpload
	  },
	  data () {
	    return {
		time:this.$route.query.time,
		liushui:this.$route.query.liushui,
		isvip:this.$route.query.isvip,
		game:this.$route.query.game,
		tname:this.$route.query.tname,
		jd:this.$route.query.jd,
		mid:this.$route.query.mid,
		vip:'',
		thejd:'',
		word:'',
		word1:'',
		imgList:'',
		show:false,
		num:'',
	    objData:[{id: 4, game: "仙境传说起源", type: "1", order: 5, show: null}],
		  qData:[],
	    page:1,
		  s1:false,
	  	s2:false,
	  	s3:false,
		  total:0,
		  degree:''
	    }
	  },
	  created() {
	  //this.getGameName()
		this.getMessage()
		this.jD(this.jd)
		this.isVip(this.isvip)
	  },
	  methods:{
	  	// getGameName() {
	  	//   this.$axios({
	  	//     method: 'get',
	  	//     url: '/index.php/user/User/index'
	  	//   }).then(res => {
	  	//     if(res.data.status==200){
	  	//     this.objData=res.data.data
	  	//     }
	  	//   })
	  	// },
		sub(){
			if(this.word.length!=0){
				this.$axios({
				  method: 'post',
				  url: '/index.php/user/User/submitMessage',
				  data: {
				  mid:this.mid,
					word:this.word,
					pic:this.imgList
				  }
				}).then(res => {
				  if(res.data.status==500){
					this.$message({
					  type: 'error',
					  message:res.data.data,
					  offset:300
					});
				  }else if(res.data.status==200){
					  this.$message({
					    message:"提交成功！",
						offset:300
					  });
					  this.word=''
					  this.pic=''
				  }
				})
			}else{
				this.$message({
				  type: 'error',
				  message:"信息不能为空！",
				  offset:300
				});
			}
		},
		getMessage(){
			this.$axios({
			  method: 'get',
			  url: '/index.php/user/User/message',
			  params: {
			    mid:this.mid,
				page:this.page
			  }
			}).then(res => {
			  if(res.data.status==200){
			  this.degree=res.data.degree
			  this.total=res.data.count
			  this.qData=res.data.data
			  this.jD(this.jd)
			  }
			})
		},
		sub1(){
			if(this.num==5){
				this.sub2()
			}else{
				if(this.word1.length==0){
					this.$message({
					  type: 'error',
					  message:"信息不能为空！",
					  offset:300
					});
				}else{
					this.sub2()
				}
			}
		},
		sub2(){
			this.$axios({
			  method: 'post',
			  url: '/index.php/user/User/submitDegree',
			  data: {
			    mid:this.mid,
				data:this.word1,
				grade:this.num
			  }
			}).then(res => {
				if(res.data.status==200){
					this.$message({
						message:"提交成功！",
						offset:300
					});
					this.show=false
					this.word1=''
					this.num=''
				}
			})
		},
		isVip(msg){
			if(msg=="false"||msg==''){
				this.vip="非贵宾用户"
			}else if(msg=='true'){
				this.vip="贵宾用户"
			}else{
        this.vip=msg
      }
		},
		jD(num){
			if(num==0){
				this.thejd="未审核"
			}else if(num==1){
				this.thejd="工单处理中"
			}else if(num==2){
				return"工单已经批注"
			}else if(num==3){
				this.thejd="已拒绝"
			}else if(num==4){
				if(this.degree=="0"){
					this.show=true
				}
				this.thejd="已完成"
			}else if(num==5){
				this.thejd="问题受理中"
			}else if(num==6){
				this.thejd="跟进中"
			}
		},
		handleCurrentChange: function(currentPage){
			this.page = currentPage;
			this.getMessage()
		},
		an(num){
			if(num==1){
				this.s1=!this.s1
			}else if(num==2){
				this.s2=!this.s2
			}else{
				this.s3=!this.s3
			}
		},
	  }
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/tracking.vue